var React = require('react');

function InfoFilled (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},React.createElement("path",{"d":"M15 30C6.7 30 0 23.3 0 15S6.7 0 15 0s15 6.7 15 15-6.7 15-15 15zm-1-18v10h2V12h-2zm0-4v2h2V8h-2z","fillRule":"nonzero"})));
}

InfoFilled.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = InfoFilled;

InfoFilled.default = InfoFilled;
